import { Avatar, Theme } from '@mui/material';
import { QuestionStats } from '@par/shared/types/question-stats';
import { average, isTimedOut, roundToOneDecimal, sum } from '../../room/utils';
import React from 'react';
import { CustomQuestionStats } from './CQTable';
import { formattedScore } from '../../room/game/scorecard-multi';

export const getSeenCount = (stats: QuestionStats) => {
  if (!stats) {
    return null;
  }
  const scoreCounts = stats.scoreCounts;
  const seencount = sum(Object.values(scoreCounts).map((sc) => sc.length));
  return seencount;
};

export const getAvgScoreGraphic = (
  theme: Theme,
  medianScore: number,
  par: number
) => {
  if (medianScore === undefined || medianScore === null) {
    return '--';
  }
  const { avatarShape, scoreStyle } = getScoreStyle(theme, medianScore, par);
  return (
    <Avatar sx={scoreStyle} variant={avatarShape}>
      {formattedScore(medianScore)}
    </Avatar>
  );
};

const getScoreStyle = (theme: Theme, score: number, par: number) => {
  let scoreStyle: any = {
    bgcolor: theme.palette.mode === 'dark' ? '#434343' : 'undefined',
    color: 'error.contrastText',
    fontSize: '16px',
  };
  let avatarShape: any = 'rounded';
  if (score < 0) {
    scoreStyle = underParScoreBallStyle;
    avatarShape = 'round';
  }
  if (isTimedOut(par, score)) {
    scoreStyle = timedoutScoreBallStyle;
    avatarShape = 'square';
  }
  return { avatarShape, scoreStyle };
};

const underParScoreBallStyle = (theme: Theme) => ({
  bgcolor: `${theme.palette.underPar.main}40`,
  color: 'text.primary',
  textAlign: 'center',
  boxShadow: `0 0 5px 1px ${theme.palette.underPar.main}, 0 0 2px 3px ${theme.palette.underPar.main} inset`,
  fontSize: '16px',
  width: '50px',
});

const timedoutScoreBallStyle = (theme: Theme) => ({
  bgcolor: `${theme.palette.error.main}40`,
  color: 'error.contrastText',
  display: 'inline-flex',
  boxShadow: `0 0 5px 1px ${theme.palette.error.main}, 0 0 2px 3px ${theme.palette.error.main} inset`,
  fontSize: '16px',
});

export const getScoreFromStats = (question: CustomQuestionStats) => {
  if (!question.stats) {
    return null;
  }
  const scoreCountsArr = Object.values(question.stats.scoreCounts).map(
    (sc) => sc.length
  );
  const scores = [];
  for (let i = 0; i < scoreCountsArr.length; i++) {
    const scoreSpread = new Array(scoreCountsArr[i]).fill(i - question.par);
    scores.push(...scoreSpread);
  }
  const avgScore = average(scores);
  return roundToOneDecimal(avgScore);
};
